/* eslint-disable import/prefer-default-export */
import { BIControlPanel } from '../interfaces/BIControlPanel';

export const enUS: BIControlPanel = {
  title: 'BI Control Panel',
  tabs: {
    invoiceValue: 'BI Invoice Value',
    approvalStatus: 'Status Approval',
    parameterRules: 'BI Parameters',
  },
  filters: {
    placeholder: 'Select',
    noData: 'No results found',
    endText: 'All items have been loaded',
    expandedTooltip: 'Hide search options',
    collapsedTooltip: 'Expand search options',
    panelExpanded: 'Panel open',
    panelCollapsed: 'Panel closed',
    financialGroupRequired: 'Financial group*',
    financialGroup: 'Financial group',
    contract: 'Contract',
    subcontract: 'Subcontract',
    carrier: 'Carrier',
    competency: 'Competency',
  },
  table: {
    rowsPerPage: 'Rows per page',
    of: 'of',
    invoiceValue: 'Invoice value',
    invoicePageTotal: 'Page total',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    lastUpdateDate: 'Last update date',
    updateUser: 'Update user',
  },
  messages: {
    parametersPanelLoadError: 'An error occurred while loading the parameters panel.',
    approvalPanelLoadError: 'An error occurred while loading the approval panel.',
    additionalFiltersLoadError: 'An error occurred while loading the additional filters.',
    filterOptionsLoadError: 'An error occurred while fetching the filter options.',
    filtersClearError: 'An error occurred while clearing the filters.',
    dataSearchError: 'An error occurred while searching the data.',
    tableDataSearchError: 'An error occurred while fetching the BI table data.',
    statusUpdateError: 'An error occurred while updating the status.',
    pageChangeError: 'An error occurred while changing the page.',
    pageSizeChangeError: 'An error occurred while changing the row count.',
  },
  parameterRules: {
    filters: {
      carrier: 'Carrier',
      carrierRequired: 'Carrier*',
      paymentModel: 'Model',
      financialGroup: 'Financial group',
      contract: 'Contract',
      status: 'Status',
    },
    table: {
      levelType: 'Level type',
      levelOption: 'Level option',
      paymentModel: 'Model',
      rule: 'Rule',
      ruleStatus: 'Rule status',
      actions: 'Actions',
      active: 'Active',
      inactive: 'Inactive',
      noData: 'No items found',
      newRule: 'New rule',
    },
    actions: {
      edit: 'Edit',
      ruleHistory: 'Rule history',
      parameterHistory: 'Parameter history',
      activateRule: 'Activate rule',
      deactivateRule: 'Deactivate rule',
    },
    levels: {
      CARRIER: 'Carrier',
      FINANCIAL_GROUP: 'Financial Group',
      CONTRACT: 'Contract',
    },
    paymentModels: {
      PRE_PAGAMENTO: 'Prepayment',
      POS_PAGAMENTO: 'Postpayment',
    },
    parameterTypes: {
      LIFE_COUNT: 'Life Count',
      COMPETENCY: 'Competency Display',
    },
    lifeCountRules: {
      PC: 'PC',
      FATURA: 'Invoice',
      DADO_FECHADO: 'Closed Data',
    },
    competencyTypes: {
      MENSAL: 'Monthly',
      QUINZENAL: 'Biweekly',
    },
    wizard: {
      createTitle: 'New Rule',
      editTitle: 'Edit Rule',
      step1: 'Select a Level',
      step2: 'Configure Parameter',
      levelType: 'Level type *',
      carrier: 'Carrier *',
      financialGroup: 'Financial group *',
      contract: 'Contract *',
      paymentModels: 'Model *',
      parametersSectionTitle: 'Parameter details',
      parametersSectionDescription: 'Select the parameter type and inform the value that will be applied to the rule.',
      parameterType: 'Type',
      parameterValue: 'Value',
      active: 'Active',
      addParameter: 'Add new parameter',
      back: 'Back to previous step',
      cancel: 'Cancel',
      advance: 'Next',
      save: 'Save Rule',
    },
    messages: {
      loadError: 'An error occurred while loading the data.',
      filterOptionsLoadError: 'An error occurred while fetching the filter options.',
      filtersClearError: 'An error occurred while clearing the filters.',
      searchError: 'An error occurred while searching the data.',
      statusUpdateError: 'An error occurred while updating the status.',
      saveError: 'An error occurred while saving the rule.',
      duplicateParameterType: 'An active parameter of this type already exists for this rule.',
      duplicateRule: 'An active rule already exists for this level and scope.',
      historyLoadError: 'An error occurred while fetching the history.',
      parameterRequired: 'Add at least one parameter to the rule.',
    },
    history: {
      revTypes: {
        ADD: 'Creation',
        MOD: 'Change',
        DEL: 'Deletion',
      },
      attributes: {
        active: 'Status',
        level: 'Level Type',
        carrierId: 'Carrier',
        financialGroupId: 'Financial Group',
        contractId: 'Contract',
        paymentModels: 'Model',
        parameterType: 'Type',
        lifeCountRule: 'Value',
        competencyType: 'Value',
        ruleId: 'Rule',
      },
    },
  },
};
